import type React from 'react';

import type { ILeftFilterVersColumnsItem } from '../hooks/useTableTreeLeftFilterVersColumns';

interface ILeftFilterTitleCell {
    item: ILeftFilterVersColumnsItem;
}

export const LeftFilterTitleCell: React.FC<ILeftFilterTitleCell> = (props) => {
    const { item } = props;

    return <span>{item.title}</span>;
};

LeftFilterTitleCell.displayName = 'LeftFilterTitleCell';
